import React, { useState } from 'react'
import './styles.scss'
import RemoveIcon from 'assets/shop/Remove.png'
import AddIcon from 'assets/shop/next-quantity.svg'
import ReduceIcon from 'assets/shop/back-quantity.svg'
import ReduceIconDisabled from 'assets/shop/next-quantity-disabled.svg'
import { numberWithCommas } from 'utils/priceConvert'
import { useCartContext } from 'context/shop/CartProvider'

const CartItem = (props) => {
  const { updateItem, removeItem } = useCartContext()
  const { item } = props
  const [quantity, setQuantity] = useState(item.quantity)

  // handle quantity for each product
  const updateQuantity = (newQuantity) => {
    setQuantity(newQuantity)
    updateItem(item.slug, newQuantity)
  }

  // handle add and reduce quantity for each product
  const handleIncreaseQuantity = () => {
    updateQuantity(quantity + 1)
  }

  const handleDecreaseQuantity = () => {
    if (quantity > 1) {
      updateQuantity(quantity - 1)
    }
  }

  const totalItemPrice = quantity * item.price

  return (
    <div className="cart__item">
      <div className="cart__item__detail">
        <div className="cart__item__detail__image">
          <img src={item.image} alt="product img" />
        </div>
        <div className="cart__item__detail__content">
          <span>{item.name}</span>
          <div>
            Size <span className="cart__item__detail__content__size">{item.size}</span>
          </div>

          <span>${numberWithCommas(item.price)}</span>
        </div>
      </div>

      <div className="cart__item__quantity">
        <button
          className="cart__item__quantity__reduce"
          disabled={quantity === 1}
          onClick={handleDecreaseQuantity}
        >
          <img src={quantity === 1 ? ReduceIconDisabled : ReduceIcon} alt="reduce icon" />
        </button>
        <div className="cart__item__quantity__input">{quantity}</div>
        <button className="cart__item__quantity__add" onClick={handleIncreaseQuantity}>
          <img src={AddIcon} alt="add icon" />
        </button>
      </div>

      <div className="cart__item__total">
        <span> ${numberWithCommas(totalItemPrice, 2)}</span>
      </div>
      <div className="cart__item__remove">
        <img src={RemoveIcon} onClick={() => removeItem(item)} alt="remove" />
      </div>
    </div>
  )
}

export default CartItem
